// context.js
import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'

export const Context = createContext()

const MainContext = ({ children }) => {
  const [user, setUser] = useState({})
  const [courseState, setCourseState] = useState({
    courseName: '',
    courseCategory: '',
    courseDescription: '',
    courseAbout: '',
    courseAvatar: '', //url
    courseDetails: {
      statistics: {
        creditHours: '',
        fees: '',
        graduates: '',
        duration: '',
      },
      courseQualifications: [],
      applicationRequirements: [],
      courseOutline: {},
    },
  })

  return (
    <Context.Provider value={{ user, setUser, courseState, setCourseState }}>
      {children}
    </Context.Provider>
  )
}

MainContext.propTypes = {
  children: PropTypes.element,
}
export default MainContext
